import React, {Component} from 'react';
import {translate} from 'react-i18next';
import * as moment from 'moment';
import 'moment/locale/de';
import swal from 'sweetalert';

class SupporterCommentsBlock extends Component {

    constructor(props) {
        super(props);

        this.reloadComments = this.reloadComments.bind(this);
        this.handleChangeAddEditText = this.handleChangeAddEditText.bind(this);
        this.handleSaveAddEditComment = this.handleSaveAddEditComment.bind(this);
        this.handleDeleteComment = this.handleDeleteComment.bind(this);
        this.handleBookmarkComment = this.handleBookmarkComment.bind(this);
        this.handleSaveAddEditCommentByShortcut = this.handleSaveAddEditCommentByShortcut.bind(this);
    }

    componentDidMount() {
        this.props.getComments(this.props.supporterId);
    }

    isWithinSixMonths(date) {
        const sixMonthsAgo = moment().subtract(6, 'months');
        return moment(date).isAfter(sixMonthsAgo);
    }

    reloadComments() {
        this.props.getComments(this.props.supporterId);
    }

    handleChangeAddEditText(e) {
        this.props.changeAddEditText(e.target.value);
    }

    handleSaveAddEditComment() {
        this.props.saveAddEditComment({
            supporterId: this.props.supporterId,
            message: this.props.supporterComments.addEditText,
            edit: this.props.supporterComments.edit,
            add: this.props.supporterComments.add
        })
    }

    handleDeleteComment(commentId) {
        const {t} = this.props;

        swal({
            title: t('supporter.supporterComments.delete.really.title'),
            text: t('supporter.supporterComments.delete.really.text'),
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((reallyDo) => {
            if (reallyDo) {
                this.props.deleteComment({
                    supporterId: this.props.supporterId,
                    commentId
                })
            }
        })
    }

    handleBookmarkComment(commentId, isPinned) {
        if (!commentId) {
            return;
        }


        this.props.bookmarkComment({
            supporterId: this.props.supporterId,
            commentId,
            isPinned: !isPinned
        })
    }

    handleSaveAddEditCommentByShortcut(e) {
        if ((e.ctrlKey || e.metaKey) && (e.charCode === 13 || e.charCode === 10)) {
            this.handleSaveAddEditComment()
        }
    }

    render() {
        const {t, supporterComments} = this.props;
        return (
            <div className="SupporterCommentsBlock ibox">
                <div className="ibox-title">
                    <h5>{t('supporterScreen.supporterComments.title')}</h5>
                    <div className="ibox-tools">
                        {(supporterComments.edit || supporterComments.add) ? (
                            <div>
                                <a onClick={this.props.undoAddEditComment} className="btn btn-default m-r-xs">
                                    <i className="fa fa-undo"/>
                                </a>
                                <button onClick={this.handleSaveAddEditComment} className="btn btn-primary"
                                        disabled={supporterComments.loading}>
                                    {supporterComments.loading ? (
                                        <i className='fa fa-spinner fa-spin inline-block m-r'/>
                                    ) : null}
                                    <i className="fa fa-save"/>
                                </button>
                            </div>
                        ) : (
                            <a onClick={this.props.addComment}>
                                <i id="addSupporterCommentButton" className="fa fa-plus fa-1-5x"/>
                            </a>
                        )}
                    </div>
                </div>
                <div className="ibox-content no-padding">
                    {(supporterComments.add || supporterComments.edit) ? (
                        <div className="addEditBox">
                            <div className="p-sm">
                                <label>
                                    {t('supporterScreen.supporterComments.addEditMessage.label')}
                                </label>
                                <textarea autoFocus id="supporterCommentTextArea" className="form-control" onChange={this.handleChangeAddEditText} onKeyPress={this.handleSaveAddEditCommentByShortcut} value={supporterComments.addEditText}/>
                                {(supporterComments.errors && supporterComments.errors.message) ? (
                                    <span className="help-block text-danger">
                                            {t('supporterComments.message.error.' + supporterComments.errors.message)}
                                        </span>
                                ) : null}
                            </div>

                            <div className="hr-line-dashed"/>
                        </div>
                    ) : null }
                    <ul className="list-group">
                        {supporterComments.comments ? supporterComments.comments.map((supporterComment, i) => (
                            <li className={`list-group-item ${supporterComment.isPinned && 'BookmarkedComment'} ${!this.isWithinSixMonths(supporterComment.createdAt) && !supporterComment.isPinned && 'light-gray-bg'}`} key={i}>
                                <p>
                                    <small className="pull-right text-muted">
                                        {moment(supporterComment.createdAt).format('DD.MM.YYYY HH:mm')}
                                        <div className="pull-right btn-group btn-group-xs m-l-xs">
                                            <button className={`btn btn-${supporterComment.isPinned ? 'info' : 'default'}`} value={supporterComment.id} onClick={() => this.handleBookmarkComment(supporterComment.id, supporterComment.isPinned)}>
                                                <i className="fa fa-bookmark" />
                                            </button>
                                        </div>
                                    </small>
                                    <span className="text-info block">
                                        {supporterComment.createdBy.username}
                                    </span>
                                </p>
                                <p>
                                    {supporterComment.deleteable ? (
                                        <div className="pull-right btn-group btn-group-xs">
                                            <button type="button" className="btn btn-danger"
                                                    onClick={() => this.handleDeleteComment(supporterComment.id)}>
                                                <i className="fa fa-trash"/>
                                            </button>
                                        </div>
                                    ) : null }
                                    {supporterComment.message}
                                </p>
                            </li>
                        )) : null}
                    </ul>
                </div>
            </div>
        )
    }
}

export default translate()(SupporterCommentsBlock);